import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomBarcodeEnlarged({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M.682 5H.227A.227.227 0 010 4.773V.227C0 .102.102 0 .227 0h4.546C4.898 0 5 .102 5 .227v.455a.227.227 0 01-.227.227H1.136a.227.227 0 00-.227.227v3.637A.227.227 0 01.682 5zM4.773 20H.227A.227.227 0 010 19.773v-4.546C0 15.102.102 15 .227 15h.455c.125 0 .227.102.227.227v3.637c0 .125.102.227.227.227h3.637c.125 0 .227.102.227.227v.455a.227.227 0 01-.227.227zM19.773 20h-4.546a.227.227 0 01-.227-.227v-.455c0-.125.102-.227.227-.227h3.637a.227.227 0 00.227-.227v-3.637c0-.125.102-.227.227-.227h.455c.125 0 .227.102.227.227v4.546a.227.227 0 01-.227.227zM19.773 5h-.455a.227.227 0 01-.227-.227V1.136a.227.227 0 00-.227-.227h-3.637A.227.227 0 0115 .682V.227c0-.125.102-.227.227-.227h4.546c.125 0 .227.102.227.227v4.546a.227.227 0 01-.227.227z" />
        <g>
          <path d="M3 4.8h.875v10.577H3zM13.719 4.8h.437v10.577h-.437zM5.844 4.8h.437v10.577h-.437zM11.75 4.8h.875v10.577h-.875zM4.75 4.8h.875v10.577H4.75zM8.469 4.8h.437v10.577H8.47zM7.375 4.8h.875v10.577h-.875zM16.344 4.8h.437v10.577h-.437zM15.25 4.8h.875v10.577h-.875zM9.344 4.8h.437v10.577h-.437zM10 4.8h.875v10.577H10z" />
        </g>
      </g>
    </svg>
  );
}
export default SvgIconCustomBarcodeEnlarged;
